import PropertyRoomInfoCard from './PropertyRoomInfoCard';

export default PropertyRoomInfoCard;
